module.exports = __webpack_public_path__ + "img/clothing47.68f86278.jpg";